export default {
    formId: 'confirmarForm',
    formField: {
        // SECCION POLIZA
        fechaEmision: {
            name: 'fechaEmision',
            label: 'Fecha de Emisión *',
            requiredErrorMsg: 'Debe especificar una fecha'
        },
        comentariosSolicitud: {
            name: 'comentariosSolicitud',
        },
        frecuenciaPago: {
            name: 'frecuenciaPago',
            label: 'Frecuencia de pago*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        cuotas: {
            name: 'cuotas',
            label: 'Cantidad de cuotas*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        ajusteAutomatico : {
            name: 'ajusteAutomatico',
            label: 'Ajuste automático',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        vigenciaDesde: {
            name: 'vigenciaDesde',
            label: 'Vigencia Desde *',
            requiredErrorMsg: 'Debe especificar una fecha'
        },
        vigenciaHasta: {
            name: 'vigenciaHasta',
            label: 'Vigencia Hasta *',
            requiredErrorMsg: 'Debe especificar una fecha'
        },
        formaDePago: {
            name: 'formaDePago',
            label: 'Forma De Pago *',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        moduloCobertura: {
            name: 'moduloCobertura',
            label: 'Módulo de la cobertura *',
            requiredErrorMsg: 'Debe especificar la cobertura'
        },
        numeroTramite: {
            name: 'numeroTramite',
            label: 'Número de Tramite *',
            requiredErrorMsg: 'Debe completar el número de trámite'
        },
        numeroPoliza: {
            name: 'numeroPoliza',
            label: 'Número de Póliza *',
            requiredErrorMsg: 'Debe seleccionar el número de póliza'
        },
        numeroReferencia: {
            name: 'numeroReferencia',
            label: 'Número de Referencia *',
            requiredErrorMsg: 'Debe seleccionar el número de referencia'
        },
        premium: {
            name: 'premium',
            label: 'Cuota Mensual *',
            requiredErrorMsg: 'Debe indicar el valor de la cuota mensual'
        },
        //    SECCIÓN CLIENTE
        cliente: {
            rol: {
                name: 'rol',
                label: 'Rol *',
                requiredErrorMsg: 'Debe seleccionar una opción'
            },
            personaJuridica: {
                name: 'personaJuridica',
                label: 'Tipo Persona',
                requiredErrorMsg: 'Debe seleccionar una opción'
            },
            dni: {
                name: 'dni',
                label: 'DNI *',
                requiredErrorMsg: 'Debe especificar este campo'
            },
            cuit: {
                name: 'cuit',
                label: 'CUIT/CUIL *',
                requiredErrorMsg: 'Debe especificar el CUIT/CUIL'
            },
            nombre: {
                name: 'nombre',
                label: 'Nombre*',
                requiredErrorMsg: 'Debe especificar este campo'
            },
            apellido: {
                name: 'apellido',
                label: 'Apellido *',
                requiredErrorMsg: 'Debe especificar este campo'
            },
            fechaNacimiento: {
                name: 'fechaNacimiento',
                label: 'Fecha de nacimiento *',
                requiredErrorMsg: 'Debe especificar la fecha de nacimiento'
            },
            estadoCivil: {
                name: 'estadoCivil',
                label: 'Estado civil *',
                requiredErrorMsg: 'Debe seleccionar un estado civil'
            },
            sexo: {
                name: 'sexo',
                label: 'Sexo *',
                requiredErrorMsg: 'Debe seleccionar un sexo'
            },
            domicilio: {
                name: 'domicilio',
                label: 'Dirección de domicilio *',
                requiredErrorMsg: 'Debe especificar una dirección de domicilio'
            },
            codigosLocalidad: {
                name: 'codigosLocalidad',
                label: 'Código postal / Localidad',
                requiredErrorMsg: 'Debe seleccionar una opción'
            },
            codigoArea: {
                name: 'codigoArea',
                label: 'Código de área *',
                requiredErrorMsg: 'Debe especificar el código de área'
            },
            telefono: {
                name: 'telefono',
                label: 'Celular *',
                requiredErrorMsg: 'Debe especificar un celular'
            },
            email: {
                name: 'email',
                label: 'Email *',
                requiredErrorMsg: 'Debe especificar un email'
            },
            situacionIva: {
                name: 'situacionIva',
                label: 'Situación ante el IVA *',
                requiredErrorMsg: 'Debe seleccionar una opción'
            },
            categoriaMonotributo: {
                name: 'categoriaMonotributo',
                label: 'Categoría de monotributo *',
                requiredErrorMsg: 'Debe seleccionar una opción'
            },
            actividadPrincipal: {
                name: 'actividadPrincipal',
                label: 'Actividad principal (CIIU de AFIP) *',
                requiredErrorMsg: 'Debe seleccionar una opción'
            },
            lugarNacimiento: {
                name: 'lugarNacimiento',
                label: 'Lugar de nacimiento *',
                requiredErrorMsg: 'Debe especificar un lugar de nacimiento'
            }
        },
        emailDespachoElectronico: {
            name: 'emailDespachoElectronico',
            label: 'Email al que enviaremos la documentación *',
            requiredErrorMsg: 'Debe especificar un email'
        },
        descuentoCliente: {
            name: 'descuentoCliente'
        },
        //SECCIÓN VEHÍCULO
        outStandardSancor: {
            name: 'outStandardSancor',
            label: 'Fuera de pauta *',
            requiredErrorMsg: 'Inidque si el auto está fuera de pauta'
        },
        vehiculo: {
            equipoDeRastreo: {
                name: 'equipoDeRastreo',
                label: 'Solicitar equipo de rastreo *',
                requiredErrorMsg: 'Debe seleccionar una opción'
            },
            marca: {
                name: 'marca',
                label: 'Marca',
                requiredErrorMsg: ''
            },
            modelo: {
                name: 'modelo',
                label: 'Modelo',
                requiredErrorMsg: ''
            },
            anio: {
                name: 'anio',
                label: 'Año',
                requiredErrorMsg: 'Debe especificar el año del modelo'
            },
            tipoUso: {
                name: 'tipoUso',
                label: 'Uso *',
                requiredErrorMsg: 'Debe seleccionar una opción'
            },
            valor: {
                name: 'valor',
                label: 'Valor del vehículo *',
                requiredErrorMsg: 'Debe especificar el valor del vehículo'
            },
            ceroKm: {
                name: 'ceroKm',
                label: 'Vehículo 0 Km *',
                requiredErrorMsg: 'Debe seleccionar una opción'
            },
            patente: {
                name: 'patente',
                label: 'Patente *',
                requiredErrorMsg: 'Debe especificar la patente'
            },
            motor: {
                name: 'motor',
                label: 'Número de motor *',
                requiredErrorMsg: 'Debe especificar el número de motor'
            },
            chasis: {
                name: 'chasis',
                label: 'Número de chasis *',
                requiredErrorMsg: 'Debe especificar el número de chasis'
            },
            tieneGnc: {
                name: 'tieneGnc',
                label: 'Tiene equipo de GNC *',
                requiredErrorMsg: 'Debe seleccionar una opción'
            },
            gnc: {
                marcaRegulador: {
                    name: 'marcaRegulador',
                    label: 'Marca del regulador *',
                    requiredErrorMsg: 'Debe especificar la marca del regulador'
                },
                numeroRegulador: {
                    name: 'numeroRegulador',
                    label: 'Número del regulador *',
                    requiredErrorMsg: 'Debe especificar el número del regulador'
                },
                cilindros: {
                    marcaCilindro: {
                        name: 'marcaCilindro',
                        label: 'Marca del cilindro *',
                        requiredErrorMsg: 'Debe especificar la marca del cilindro'
                    },
                    numeroCilindro: {
                        name: 'numeroCilindro',
                        label: 'Número del cilindro *',
                        requiredErrorMsg: 'Debe especificar el número del cilindro'
                    },
                },
                valorTotal: {
                    name: 'valorTotal',
                    label: 'Valor del equipo de GNC *',
                    requiredErrorMsg: 'Debe especificar el valor del equipo'
                }
            },
            inspeccionPrevia: {
                comentariosInspeccion: {
                    name: 'comentariosInspeccion',
                },
                fechaInspeccion: {
                    name: 'fechaInspeccion',
                    label: 'Fecha de la inspección *',
                    requiredErrorMsg: 'Debe especificar la fecha de inspección'
                },
                tipoCombustible: {
                    name: 'tipoCombustible',
                    label: 'Tipo de combustible *',
                    requiredErrorMsg: 'Debe seleccionar una opción'
                },
                aspectoGeneral: {
                    name: 'aspectoGeneral',
                    label: 'Aspecto general del vehículo',
                    requiredErrorMsg: ''
                },
                estadoCristales: {
                    name: 'estadoCristales',
                    label: 'Estado de los cristales *',
                    requiredErrorMsg: 'Debe seleccionar una opción'
                },
                resultadoInspeccion: {
                    name: 'resultadoInspeccion',
                    label: 'Resultado de la inspección *',
                    requiredErrorMsg: 'Debe seleccionar una opción'
                },
                kilometraje: {
                    name: 'kilometraje',
                    label: 'Kilometraje *',
                    requiredErrorMsg: 'Debe especificar el kilometraje'
                },
                aspectoPintura: {
                    name: 'aspectoPintura',
                    label: 'Aspecto de la pintura',
                    requiredErrorMsg: ''
                },
                tipoPintura: {
                    name: 'tipoPintura',
                    label: 'Tipo de pintura',
                    requiredErrorMsg: ''
                },
                aspectoChapa: {
                    name: 'aspectoChapa',
                    label: 'Aspecto de la chapa',
                    requiredErrorMsg: ''
                },
                aspectoNeumaticos: {
                    name: 'aspectoNeumaticos',
                    label: 'Aspecto de los neumáticos',
                    requiredErrorMsg: ''
                },
                aspectoTapizado: {
                    name: 'aspectoTapizado',
                    label: 'Aspecto del tapizado',
                    requiredErrorMsg: ''
                },
                colorTapizado: {
                    name: 'colorTapizado',
                    label: 'Color del tapizado',
                    requiredErrorMsg: ''
                },
                tipoTapizado: {
                    name: 'tipoTapizado',
                    label: 'Tipo de tapizado',
                    requiredErrorMsg: ''
                },
                colorVehiculo: {
                    name: 'colorVehiculo',
                    label: 'Color del vehículo *',
                    requiredErrorMsg: 'Debe especificar el color del vehículo'
                },
                tipoLlantas: {
                    name: 'tipoLlantas',
                    label: 'Tipo de llantas',
                    requiredErrorMsg: ''
                }
            },
        },
        bienesAsegurados: {
            id: {
                name: 'id',
                label: 'Bien asegurado *',
                requiredErrorMsg: 'Debe seleccionar una opción'
            },
            descripcion: {
                name: 'descripcion',
                label: 'Descripción *',
                requiredErrorMsg: 'Debe completar la descripción'
            },
            suma: {
                name: 'suma',
                label: 'Suma asegurada *',
                requiredErrorMsg: 'Debe especificar el monto'
            },
        },
    }
};
